import Floahverfi from './floahverfid'
import Skogarhverfi from './skogarhverfi'
import Sementsreitur from './sementsreitur'
import Aedaroddi from './aedaroddi'

const hverfi = {
  floahverfid: Floahverfi,
  skogarhverfi: Skogarhverfi,
  sementsreitur: Sementsreitur,
  aedaroddi: Aedaroddi,
}

export default hverfi
